<template>
<div>
    <my-header></my-header>
    <div class="pd20">
        <div v-if="error" class="alert alert-warning">
              {{ error }}
        </div>
        <div v-else>
          <loading :text="'Please wait'|translate" v-if="loading"></loading>
        <p v-if="!item">{{'No result'|translate}}</p>

        <div class="land-detail" v-if="item">
            <div class="row">
                <div class="col-md-9 mb20">
                    <ol class="breadcrumb">
                        <li>
                            <router-link :to="{ name: 'Home', params: {}}">{{'Home'|translate}}</router-link>
                        </li>

                        <li class="active">Xem tin</li>
                    </ol>
                    <h3>Xem tin</h3>
                    <p class="meta" >
                      <i class="fas fa-tag"></i>
                        <strong>{{'Price'|translate}}:</strong> <span class="price">{{toCommas(item.unit_price * 1000)}} </span>đ/kg.
                    </p>
                    <p>
                      <i class="fas fa-box"></i>
                        <strong>Số lượng dự kiến:</strong> {{toCommas(item.estimate_quantity)}} tấn.
                    </p>
                    <p>
                      <i class="fa-solid fa-calendar-days"></i>
                        <strong>Ngày tuổi trái :</strong> {{item.growing_days}} ngày.
                    </p>
                    <p >
                        <i class="fas fa-map-marker-alt"></i>
                        <strong>Địa chỉ</strong>: {{item.full_address}}.
                    </p>
                    <hr />
                    <div class="description" v-html="item.description"></div>

                    <div >
                        <p class="mt20">
                            <i class="fas fa-images"></i>
                            <strong>{{'Attached images'|translate}}</strong>
                        </p>
                        <div class="gallery">
                            <p v-if="item.photos.length == 0">{{'There is no attach photo'|translate}}</p>
                            <a v-else class="wrap" v-for="(photo, photoIndex) in item.photos" :key="photoIndex" @click="index = photoIndex">
                                <img class="thumb" :src="photo.thumb_path" />
                            </a>
                        </div>
                    </div>
                    <gallery v-if="item.photos" :images="images" :index="index" @close="index = null"></gallery>
                </div>
                <div class="col-md-3">
                    <div class="media">
                        <div class="media-left">
                            <i class="fas fa-user-circle fa-2x"></i>
                        </div>
                        <div class="media-body">
                            <h4 class="media-heading">
                                <router-link :to="{ name: 'Profile', params: { profileId: item.user.unique_code }}">{{item.user.name}}</router-link>
                            </h4>
                        </div>
                    </div>
                    <hr />
                    <a  class="btn btn-primary" :href="'tel:'+ item.user.vn_phone">
                        <i class="fas fa-phone"></i>
                        {{item.user.vn_phone}}
                    </a>
                    <hr />
                    <div class="resources mt20">
                        <h3>{{'Thông tin thêm'|translate}}</h3>
                        
                        <div>
                          <p><strong>Đăng vào</strong>: {{ item.created_at | moment("from", "now") }}</p>
                        </div>
                          
                        

                    </div>
                </div>
            </div>
        </div>
        </div>

    </div>
</div>
</template>

<script>
// http://farmbook.com/API/listProduct
import Utils from '@/helpers/utils'
import MyHeader from '@/components/Layout/Header'
import Loading from '@/components/elements/Loading'
import gallery from 'vue-gallery'
export default {
  name: 'CoffeeMarketDetail',
  components: {
    MyHeader,
    Loading,
    gallery
  },
  data () {
    return {
      error: '',
      user: null,
      item: null,
      loading: true,
      index: null,
    }
  },
  computed: {
    images () {
      if (this.item.photos) {
        return this.item.photos.map(item => {
          return item.path
        })
      } else {
        return []
      }
    }
  },
  methods: {
    alertNeedLogin () {
      this.$alertify.error(this.$t('Bạn cần đăng nhập để xem số điện thoại'))
      window.REQUIRE_LOGIN_ROUTE_NAME = 'CoffeeMarketDetail' // set callback after login
      window.ROUTE_PARAMS = {id: this.id} // set callback after login
      this.$router.push({ name: 'Login' })
      // this.$alertify.alertWithTitle(
      //   this.$t("Confirm"),
      //   this.$t(
      //     "Bạn cần đăng nhập để xem số điện thoại"
      //   )
      // ).then(()=>{
      //   console.log('done redirect');
      // })
    },
    toCommas (value) {
      return Utils.toCommas(value)
    },
    getData () {
      Utils.requestV2(this, true)
        .get(`/agricultural-ads/${this.id}`)
        .then(response => {
          let item = response.data
          
          this.item = item
          this.loading = false
        })
        .catch(error => {
          this.updating = false
          // Utils.showErrorMessage(this, error.response)
          this.error = 'Bạn cần liên hệ admin để xem được thông tin rao bán'
        })
    }
  },
  mounted () {
    this.user = Utils.getUser(this)
    this.id = this.$route.params.id
    this.getData()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AgriculturalAd/AgriculturalAdDetail.vue